module.exports = __webpack_public_path__ + "static/media/texture-blue.129b7d2a.png";